<div class="input-wrapper">
    <ValidatedTextField class="field"
                        id="password"
                        label="Password"
                        [text]="password"
                        type="password"
                        (onValueChange)="onPasswordChange.emit($event)"
                        [validators]="[passwordValidator]">
    </ValidatedTextField>
</div>

<div class="input-wrapper">
    <ConfirmPasswordTextField class="field"
                              id="confirm-password"
                              label="Confirm password"
                              [text]="passwordConfirmation"
                              (onValueChange)="onPasswordConfirmationChange.emit($event)"
                              [originalPassword]="password">
    </ConfirmPasswordTextField>
</div>

